/**
 * Helpers for "return to origin" login redirects.
 *
 * Convention: callers navigate with `state: { from: <string path> }`
 * where path is e.g. "/category/foo?search=bar".
 * The receiver normalizes both string and legacy location-object shapes.
 */

export function getCurrentPath(location) {
  if (location?.pathname) {
    return `${location.pathname}${location.search || ""}` || "/";
  }
  if (typeof window !== "undefined") {
    return `${window.location.pathname}${window.location.search || ""}` || "/";
  }
  return "/";
}

/**
 * Resolve a safe return path from `location.state.from`.
 * Accepts:
 *  - string ("/wishlist", "/category/x?q=1")
 *  - location-like object ({ pathname, search })
 *  - full react-router location ({ pathname, search, ... })
 * Falls back to "/" and blocks open-redirects / login loops.
 */
export function resolveReturnPath(from, fallback = "/") {
  let path = fallback;

  if (typeof from === "string" && from) {
    path = from;
  } else if (from && typeof from === "object" && typeof from.pathname === "string") {
    path = `${from.pathname}${from.search || ""}`;
  }

  // Safety: only allow same-origin absolute paths, never /login itself
  if (!path.startsWith("/") || path.startsWith("//")) return fallback;
  if (path === "/login" || path.startsWith("/login?") || path.startsWith("/login#")) {
    return fallback;
  }
  return path || fallback;
}
